import type { SVGProps } from 'react';
const SvgIconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 1.75a.75.75 0 0 0-1.5 0v.75h-.5A2.5 2.5 0 0 0 1 5v7a2.5 2.5 0 0 0 2.5 2.5h9A2.5 2.5 0 0 0 15 12V5a2.5 2.5 0 0 0-2.5-2.5H12v-.75a.75.75 0 0 0-1.5 0v.75h-5zM2.5 5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1.5h-11zm0 3v4a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconCalendar;
